module.exports = __webpack_public_path__ + "static/media/logo-vp.06a0f61c.png";